import { MenuItem, Select, SelectChangeEvent, SelectProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LanguageEnum } from '~enums';

const supportedLanguages = Object.keys(LanguageEnum);

const LanguageSelect = (props: SelectProps) => {
	const { i18n } = useTranslation();

	/**
	 * Handle the change of language
	 */
	const handleLanguageChange = (event: SelectChangeEvent<unknown>) => {
		i18n.changeLanguage(event.target.value as string);
	};

	return (
		<Select {...props} value={i18n.resolvedLanguage} onChange={handleLanguageChange}>
			{supportedLanguages.map((lang: string, i: number) => (
				<MenuItem key={i} value={Object.values(LanguageEnum)[supportedLanguages.indexOf(lang)]}>
					{lang}
				</MenuItem>
			))}
		</Select>
	);
};

export default LanguageSelect;
